import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowRight } from "lucide-react";
import { SBLogo } from "../components/WebLayout";

export default function Scan() {
  const [params] = useSearchParams();
  const src = params.get("src") || "";
  const suffix = src ? `?src=${encodeURIComponent(src)}` : "";

  const options = [
    {
      title: "I MANAGE A BUSINESS",
      subtitle: "I want vending at my location.",
      to: `/businesses${suffix}`,
      testid: "scan-cta-business",
    },
    {
      title: "I'M A VENDING OPERATOR",
      subtitle: "I'm looking for locations.",
      to: `/operators${suffix}`,
      testid: "scan-cta-operator",
    },
    {
      title: "I WANT TO BECOME A SCOUT",
      subtitle: "I want to find spots and earn bounties.",
      to: `/scouts${suffix}`,
      testid: "scan-cta-scout",
    },
  ];

  return (
    <div className="min-h-screen bg-[#080B0D] text-white">
      <Helmet>
        <title>SpotBounty — See it in action</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <header className="max-w-3xl mx-auto px-6 pt-10 pb-6 flex items-center justify-between">
        <Link to={`/${suffix}`} data-testid="scan-logo">
          <SBLogo size={22} />
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 pb-24">
        <div className="sb-eyebrow" data-testid="scan-eyebrow">Welcome</div>
        <h1 className="sb-headline text-[40px] md:text-[56px] leading-[1.02] mt-3" data-testid="scan-headline">
          SEE SPOTBOUNTY<br />IN ACTION
        </h1>
        <p className="mt-4 text-[#A1A1AA] text-[15px] md:text-[16px]" data-testid="scan-subheadline">
          Choose what you're looking for.
        </p>

        <div className="mt-10 grid gap-4">
          {options.map((o) => (
            <Link
              key={o.title}
              to={o.to}
              data-testid={o.testid}
              className="sb-card p-6 md:p-7 flex items-center justify-between gap-4 group hover:border-[#FFC107] transition-colors"
              style={{ minHeight: 88 }}
            >
              <div>
                <div className="font-black text-[18px] md:text-[20px] tracking-tight">{o.title}</div>
                <div className="mt-1 text-[13px] md:text-[14px] text-[#A1A1AA]">{o.subtitle}</div>
              </div>
              <span
                className="shrink-0 w-11 h-11 rounded-full border border-[#2A2F34] flex items-center justify-center text-[#FFC107] group-hover:bg-[#FFC107] group-hover:text-[#080B0D] transition-colors"
                aria-hidden="true"
              >
                <ArrowRight size={20} />
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to={`/${suffix}`}
            data-testid="scan-learn-more"
            className="text-[13px] text-[#A1A1AA] hover:text-[#FFC107] underline underline-offset-4"
          >
            Learn about SpotBounty
          </Link>
        </div>
      </main>
    </div>
  );
}
